export const ADD = 'ADD'
export const DEL = 'DEL'
export const EQU = 'EQU'

export const TOGGLE_HISTORY = 'TOGGLE_HISTORY'



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js